import { Globe } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';

const GOOGLE_ICON = (
  <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true">
    <path
      fill="#4285F4"
      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
    />
    <path
      fill="#34A853"
      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"
    />
    <path
      fill="#FBBC05"
      d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.83z"
    />
    <path
      fill="#EA4335"
      d="M12 5.38c1.62 0 3.06.56 4.21 1.65l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"
    />
  </svg>
);

export function LoginPage() {
  const [params] = useSearchParams();
  const error = params.get('error');
  const expired = params.get('expired');
  const { user } = useAuth();

  useEffect(() => {
    if (user) window.location.href = '/';
  }, [user]);

  function startLogin() {
    window.location.href = '/api/auth/google';
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface-2 p-4">
      <div className="w-full max-w-sm bg-surface-1 border border-ink-200 rounded-xl shadow-sm p-8 space-y-6">
        <div className="text-center space-y-2">
          <div className="text-2xl font-bold flex items-center justify-center gap-2">
            <Globe className="h-7 w-7 text-brand-500" />
            <span className="text-ink-900">Atlas</span>
          </div>
          <p className="text-sm text-ink-400">
            Sistema interno de gestión de tareas operativas
          </p>
        </div>

        {error && (
          <div className="px-3 py-2 rounded-md bg-brand-50 border border-brand-200 text-sm text-brand-700">
            {decodeURIComponent(error)}
          </div>
        )}
        {expired && (
          <div className="px-3 py-2 rounded-md bg-amber-50 border border-amber-200 text-sm text-amber-800">
            Tu sesión expiró. Inicia sesión nuevamente.
          </div>
        )}

        <Button variant="secondary" size="lg" onClick={startLogin} className="w-full">
          {GOOGLE_ICON}
          <span>Iniciar sesión con Google</span>
        </Button>

        <p className="text-xs text-center text-ink-400">
          Solo emails @strd.com.mx con asignación a un equipo
        </p>
      </div>
    </div>
  );
}
